import React, { Component } from 'react'
import propTypes from 'prop-types'

import styles from './styles.scss'

/** Components */
import Input from '@/components/Input'
import InputNumber from '@/components/InputNumber'
import { PopOver } from '@/components/commons/PopOver'
import IconComponent from '@/components/commons/IconComponent'
import ColorPicker from '../../ColorPicker/index'
import { getTranslation } from '../../../store/getters/language'
import { connect } from 'react-redux'

class Border extends Component {
  state = {
    active: false,
    border: {
      type: 'hidden',
      size: '0px',
      color: '#000'
    }
  }

  componentDidMount() {
    const { type, size, color } = this.props

    this.setState({
      border: {
        type,
        size,
        color
      }
    })
  }

  handleBorder = (option, value) => this.setState(prevState => ({
    border: {
      ...prevState.border,
      [option]: value
    }
  }),
    () => this.props.onChange(this.state.border)
  )

  render() {
    const { translation } = this.props
    const { active, border } = this.state

    return (
      <div className={styles['wrapper-border']}>
        <div className={styles['wrapper-border__content']}>
          <div className={styles['wrapper-border__options']}>
            <div className={styles['wrapper-border__button-color']}>
              <button onMouseDown={() => this.setState({ active: !active })}>
                <span style={{ backgroundColor: border.color }}></span>
                <IconComponent icon="down-arrow" />
              </button>
            </div>
            <Input
              type="text"
              value={border.color}
              disabled={true}
            />
            <InputNumber
              unit={'px'}
              value={parseInt(border.size, 10)}
              onChange={({ target }) => this.handleBorder('size', target.value)}
            />
            {active && (
              <PopOver
                className={"color-popover " + styles['wrapper-border__popover']}
                hidePopover={() => this.setState({ active: false })}
              >
                <ColorPicker
                  color={border.color}
                  onChange={({ hex }) => this.handleBorder('color', hex)}
                />
              </PopOver>
            )}
          </div>

          <div className={styles['wrapper-border__borders']}>
            <div>
              <div
                className={border.type === 'hidden' ? styles['wrapper-border__active'] : ''}
                onClick={() => this.handleBorder('type', 'hidden')}
                aria-hidden={true}
              >
                <span>
                  <builderall-icon code='541c'></builderall-icon>
                </span>
              </div>
              <small>{translation('border-hidden')}</small>
            </div>
            <div>
              <div
                className={border.type === 'groove' ? styles['wrapper-border__active'] : ''}
                onClick={() => this.handleBorder('type', 'groove')}
                aria-hidden={true}
              >
                <span />
              </div>
              <small>{translation('border-groove')}</small>
            </div>
            <div>
              <div
                className={border.type === 'solid' ? styles['wrapper-border__active'] : ''}
                onClick={() => this.handleBorder('type', 'solid')}
                aria-hidden={true}
              >
                <span />
              </div>
              <small>{translation('border-solid')}</small>
            </div>
            <div>
              <div
                className={border.type === 'double' ? styles['wrapper-border__active'] : ''}
                onClick={() => this.handleBorder('type', 'double')}
                aria-hidden={true}
              >
                <span />
              </div>
              <small>{translation('border-double')}</small>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Border.propTypes = {
  type: propTypes.string,
  size: propTypes.string,
  color: propTypes.string
}

Border.defaultProps = {
  type: 'hidden',
  size: '0px',
  color: '#000'
}

const mapStateToProps = (state) => {
  const translation = getTranslation(state)
  return {
    translation
  }
}

export default connect(mapStateToProps)(Border) 


// WEBPACK FOOTER //
// ./src/components/editors/Border/index.js